module.exports = __webpack_public_path__ + "images/stickers/taco-alert@2x.60cf2c2b89c387f8c1ed.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-alert@2x.png
// module id = 0bf2
// module chunks = 12